module.exports = __webpack_public_path__ + "static/media/YM07_0.be5dc67b.jpg";